import { h } from 'preact'
import Content from '../common/Content'

type Props = {
  subject: string,
  content: string,
  fromUsername: string,
  fromEmail: string,
  onPreviewClicked: () => void,
  onEmailCreateDone: () => void
}

const CreateEmailForm = ({ subject, content, fromUsername, fromEmail, onPreviewClicked } : Props) => (
  <div className='create-email-campaign__preview' onClick={onPreviewClicked}>
    <div className='create-email-campaign__preview-header'>
      <div className='circle circle--red' /><div className='circle circle--orange' /><div className='circle circle--green' />
    </div>
    <div className='create-email-campaign__preview-subject'>
      <div>Subject</div>
      {
        subject
          ? <div className='create-email-campaign__preview-input'>{subject}</div>
          : <div className='create-email-campaign__preview-placeholder'>Enter email subject</div>
      }
    </div>
    <div className='create-email-campaign__preview-from'>
      <div>From</div>
      <div className='create-email-campaign__preview-input'>{fromUsername}</div>
      <div className='create-email-campaign__preview-meta'>&nbsp;&lt;{fromEmail} via amazonses.com&gt;</div>
    </div>
    <div className='create-email-campaign__preview-content-wrapper'>
      <div className='create-email-campaign__preview-content'>
        <Content content={content} />
      </div>
    </div>
  </div>
)

export default CreateEmailForm
